import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {useState, useEffect} from 'react'

import '../assets/css/Principais.css'
import '../assets/css/fonts.css'
import '../assets/css/colors.css'
import '../assets/css/scrollbar.css'

import '../assets/css/boxEffect.css'
import '../assets/css/boxEffectCompleta.css'

import HomePage from './HomePage.jsx'
import { Biblia } from './Biblia.jsx';
import { LiturgiaDiaria } from './LiturgiaDiaria.jsx';
import Programacao from './Programacao.jsx';
import Sobre from './Sobre.jsx';
import Pastorais from './Pastorais.jsx';
import PaginaTeste from './subPaginasStaticas/PaginaTeste.jsx';
import Sorteador from './subPaginasStaticas/Sorteador.jsx';
// firebase init
// Hosting e Git Opcional
// firebase login
// npm run build
// firebase deploy

//var windowHeight = window.screen.availHeight;
export const Main = props =>{

    const [ativaResp, setAtivaResp] = useState(null)
    useEffect(()=>{
        if (ativaResp == null){
            if (window.matchMedia("(max-width: 767px)").matches){
              setAtivaResp(true)
            }else{
                setAtivaResp(false)
            }
        }
      },[ativaResp])

  return <>
        <Router>
            <div className='containerPrincipal' style={{width: "100%"}}>
                <Routes>
                   <Route path="/" element={<HomePage ativaResp={ativaResp}/>} />
                   <Route path="/PaginaInicial" element={<HomePage ativaResp={ativaResp}/>} />
                   <Route path="/Biblia" element={<Biblia ativaResp={ativaResp}/>} />
                   <Route path="/LiturgiaDiaria" element={<LiturgiaDiaria ativaResp={ativaResp}/>} />
                   <Route path="/Programacao" element={<Programacao ativaResp={ativaResp}/>} />
                   <Route path="/Sobre" element={<Sobre ativaResp={ativaResp}/>} />
                   <Route path="/PastoraisEMovimentos" element={<Pastorais ativaResp={ativaResp}/>} />
                   <Route path="/Sorteador" element={<Sorteador ativaResp={ativaResp}/>} />
                   <Route path="/PaginaTeste" element={<PaginaTeste ativaResp={ativaResp}/>} />
                </Routes>
            </div>
        </Router>
  </>
}

export default Main;